import { z } from "zod";

const cents = z.string().regex(/^\d{1,28}$/u);
export const financeAgingSchema = z.object({
  status: z.enum(["calculated", "unavailable"]), reason: z.string(), date: z.iso.date(),
  mode: z.number().int().nullable(), direction: z.enum(["payable", "receivable", "balanced"]),
  remaining: cents, otherRemaining: cents, overdue: cents, notDue: cents, unknownDue: cents,
  rows: z.array(z.object({ id: z.string(), document: z.string(), kind: z.string(), date: z.iso.date(),
    dueDate: z.iso.date().nullable(), remaining: cents, daysPastDue: z.number().int().nullable(),
    allocations: z.array(z.object({ document: z.string(), date: z.iso.date(), amount: cents,
      origin: z.enum(["recorded", "calculated"]) })) })),
});
export type FinanceAging = z.infer<typeof financeAgingSchema>;
